import { storageAvailable } from './../../site/js/utils/storageCheck'
import { requiredFormFields } from './form-autofill-fields-list'

// eslint-disable-next-line sonarjs/cognitive-complexity
const storeFieldsInSessionStorage = form => {
  const formElements = form.elements
  const formToStore = []
  for (let i = 0; i < formElements.length; i++) {
    const inputType = formElements[i].nodeName
    if ((inputType === 'INPUT' || inputType === 'SELECT') && requiredFormFields.includes(formElements[i].name)) {
      // Both radio elements have the same name, so the unchecked one is skipped and the checked one is stored
      if (formElements[i].type === 'radio' && !formElements[i].checked) {
        continue
      }
      const formObj = { name: formElements[i].name, value: formElements[i].value }
      if (formElements[i].type === 'tel') {
        // The phone lib requires a country code for the retrieval,
        // so the countryCode from the select element is stored
        const element = document.getElementsByClassName('iti__active')[0]
        formObj.countryCode = element.getAttribute('data-country-code')
        formObj.inputName = formElements[i].dataset?.inputName || 'phone'
      }
      formToStore.push(formObj)
    }
  }
  if (storageAvailable('sessionStorage')) {
    sessionStorage.setItem('formFields', JSON.stringify(formToStore))
  }
}

// eslint-disable-next-line sonarjs/cognitive-complexity
const retrieveFieldsFromSessionStorage = field => {
  let fieldsList = []
  if (storageAvailable) {
    fieldsList = JSON.parse(sessionStorage.getItem('formFields'))
  }
  if (fieldsList) {
    const foundField = fieldsList.find(x => x.name === field.name)
    if (field.type === 'tel') {
      const foundPhoneField = fieldsList.find(x => x.inputName === field.dataset.inputName)
      if (foundPhoneField.countryCode) {
        field.iti.setCountry(foundPhoneField.countryCode)
        field.iti.setNumber(foundPhoneField.value)
        const hiddenPhoneEl = field.parentElement.querySelector(`[name=${foundPhoneField.inputName}]`)
        hiddenPhoneEl.value = field.iti.getNumber()
        field.value = foundPhoneField.value
      }
    } else if (foundField && field.nodeName === 'SELECT') {
      field.customSelect.value = foundField.value
      // Displaying the state select element
      if (foundField.name === 'stateCode' && foundField.value !== '') {
        const stateCodeEl = document.querySelector('.cmp-countriesoptions__state')
        stateCodeEl.style.display = 'block'
      }
      // Finding and setting the checked radio by value(since they have the same name)
    } else if (foundField && field.type === 'radio' && field.value === foundField.value) {
      field.checked = true
    } else if (foundField && field.type !== 'radio') {
      field.value = foundField.value
    }
  }
}
export { retrieveFieldsFromSessionStorage, storeFieldsInSessionStorage }
